import { render, staticRenderFns } from "./KeywordsImportTypePopup.vue?vue&type=template&id=70154ea0&scoped=true"
import script from "./KeywordsImportTypePopup.vue?vue&type=script&lang=js"
export * from "./KeywordsImportTypePopup.vue?vue&type=script&lang=js"
import style0 from "./KeywordsImportTypePopup.vue?vue&type=style&index=0&id=70154ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70154ea0",
  null
  
)

export default component.exports